<template>
  <div>
    <div>
      <div class="page-title-cont">
        <h1 class="wp-heading-inline">
          WPCal.io - {{ T__("Integration Settings") }}
        </h1>
        <AdminHeaderRight />
      </div>
      <SettingsMenu />
      <OnBoardingCheckList display_in="settings_integrations" />
      <div class="col-cont settings-cont">
        <div class="col">
          <div class="form">
            <div class="wpc-form-row">
              <label
                >{{ T__("My web conferencing apps") }}
                <a
                  href="https://help.wpcal.io/en/article/how-to-connect-use-meeting-apps-bwour0/?utm_source=wpcal_plugin&utm_medium=contextual"
                  target="_blank"
                  class="icon-q-mark"
                ></a
              ></label>
              <span
                class="txt-help"
                style="margin-bottom: 10px;"
                v-if="tp_accounts.length > 0"
                >{{
                  T__(
                    "After connecting your web conferencing app account below, you should edit your existing event types or create a new one and add the app as a location to use it for your bookings."
                  )
                }}</span
              >
              <div class="mbox loc-integration-accs">
                <div class="set-locations-cont">
                  <div class="set-locations-single location_googlemeet_meeting">
                    <div
                      class="txt-h5"
                      :class="{
                        loading:
                          googlemeet_meeting_is_account_connected === null
                      }"
                    >
                      <div class="app-name">
                        {{ "googlemeet_meeting" | tp_provider_name }}
                        <a
                          href="https://help.wpcal.io/en/article/how-do-i-connect-my-google-meet-with-wpcalio-hrh77h/?utm_source=wpcal_plugin&utm_medium=contextual"
                          target="_blank"
                          class="icon-q-mark"
                        ></a>
                      </div>

                      <span
                        class="status"
                        :class="{
                          enabled: googlemeet_meeting_is_account_connected,
                          disabled: !googlemeet_meeting_is_account_connected
                        }"
                        v-if="googlemeet_meeting_is_account_connected != null"
                        >{{
                          googlemeet_meeting_is_account_connected
                            ? T__("Connected")
                            : T__("Disconnected")
                        }}</span
                      >
                    </div>
                    <div class="txt-help" style="margin-bottom: 5px;">
                      {{ googlemeet_meeting_account_email }}
                    </div>
                    <div class="txt-help">
                      <span
                        v-if="googlemeet_meeting_is_account_connected === true"
                      >
                        {{
                          T__(
                            "As long as a Google Calendar account is connected, this cannot be disconnected. If you do not want to use Google Meet for your bookings, you can simply not add it as a location in your event types."
                          )
                        }}
                      </span>
                      <span
                        v-if="googlemeet_meeting_is_account_connected === false"
                        v-html="
                          Tsprintf(
                            /* translators: 1: html-tag-open 2: html-tag-close */
                            T__(
                              'This will be connected when you connect a calendar account (%1$s Settings › Calendars %2$s), and set a &quot;Add Bookings to...&quot; calendar. %3$s'
                            ),
                            '<a href=&quot;admin.php?page=wpcal_admin#/settings/calendars&quot;>',
                            '</a>',
                            '<a href=&quot;https://help.wpcal.io/en/article/how-do-i-connect-my-google-meet-with-wpcalio-hrh77h/?utm_source=wpcal_plugin&utm_medium=contextual&quot;>Learn more</a>'
                          )
                        "
                      >
                      </span>
                    </div>
                  </div>
                  <div
                    class="set-locations-single"
                    v-for="(tp_account, index) in tp_accounts"
                    :key="index"
                    :class="{
                      ['location_' + tp_account.provider]: true,
                      'del-alert': show_delete_highlight(
                        'disconnect_highlight_tp_account_index',
                        index
                      )
                    }"
                  >
                    <div class="txt-h5">
                      <div class="app-name">
                        {{ tp_account.provider | tp_provider_name }}
                        <a
                          v-if="help_links[tp_account.provider]"
                          :href="help_links[tp_account.provider]"
                          target="_blank"
                          class="icon-q-mark"
                        ></a>
                      </div>
                      <div class="account-connection-actions">
                        <OverflowMenu
                          :menu_id="tp_account.id"
                          v-model="tp_account_overflow_menu_details"
                        >
                          <a
                            class="menu-item hover-hl"
                            v-if="tp_account.status == -5"
                            @click="
                              add_tp_account(tp_account.provider, 'reauth')
                            "
                            >Reconnect</a
                          >
                          <a
                            class="menu-item del-hl"
                            style="color:#e84653; font-size:12px;"
                            @click="
                              tp_account_overflow_menu_details.open_menu_id = null;
                              show_disconnect_confirmation(tp_account);
                            "
                            @mouseover="
                              set_mouseover_on_delete(
                                'disconnect_highlight_tp_account_index',
                                index,
                                true
                              )
                            "
                            @mouseleave="
                              set_mouseover_on_delete(
                                'disconnect_highlight_tp_account_index',
                                index,
                                false
                              )
                            "
                            >{{
                              tp_account.status == "-5"
                                ? T__("Remove")
                                : T__("Disconnect")
                            }}</a
                          >
                        </OverflowMenu>
                        <span
                          class="status "
                          :class="{
                            enabled: tp_account.status == '1',
                            disabled: tp_account.status != '1'
                          }"
                          >{{
                            tp_account.status == "1"
                              ? T__("Connected")
                              : T__("Disconnected")
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="txt-help">
                      {{ tp_account.tp_account_email }}
                    </div>
                  </div>
                </div>
                <button
                  class="wpc-btn secondary md full-width"
                  @click="show_add_tp_account_list = true"
                  v-if="!show_add_tp_account_list"
                  :disabled="!enable_add_new_tp_account"
                  :title="
                    !enable_add_new_tp_account
                      ? this.T__('You have added all available apps.')
                      : ''
                  "
                >
                  {{ T__("+ Add an App") }}
                </button>
                <div v-if="show_add_tp_account_list">
                  <div class="txt-h5 caps">
                    {{ T__("Select your web conferencing app") }}
                  </div>
                  <ul class="selector block compact location">
                    <li
                      v-for="(tp_account_add_item,
                      index2) in tp_accounts_add_list_final"
                      :key="index2"
                    >
                      <label
                        @click="add_tp_account(tp_account_add_item.provider)"
                        :class="'location_' + tp_account_add_item.provider"
                        ><div class="txt-h5">
                          {{ tp_account_add_item.provider | tp_provider_name }}
                          <a
                            v-if="help_links[tp_account_add_item.provider]"
                            :href="help_links[tp_account_add_item.provider]"
                            target="_blank"
                            class="icon-q-mark"
                            @click.stop=""
                          ></a>
                        </div>
                        <div class="txt-help" style="padding-top:0;">
                          {{ T__("Web conferencing") }}
                        </div></label
                      >
                      <!-- <label
                        v-if="tp_account_add_item.provider == 'zoom_meeting'"
                        :class="'location_' + tp_account_add_item.provider"
                        ><div class="txt-h5">
                          Zoom <span class="tag">Coming soon</span
                          ><span style="float: right; font-size: 11px;"
                            ><a
                              style="margin-right: 10px;"
                              href="https://help.wpcal.io/article/how-to-use-zoom-or-any-other-app-that-uses-an-invitation-link-with-wpcal"
                              target="_blank"
                              >See a workaround
                              <span
                                style="font-size: 11px; font-weight: 600; position: absolute; margin: 2px;"
                                >↗</span
                              ></a
                            ></span
                          >
                        </div>
                        <div class="txt-help" style="padding-top:0;">
                          Web conferencing
                        </div></label
                      > -->
                    </li>
                    <li class="disabled">
                      <label class="location_ms_teams_meeting"
                        ><div class="txt-h5">Microsoft Teams</div>
                        <div class="txt-help" style="padding-top: 0px;">
                          Web conferencing
                        </div>
                        <span>COMING SOON</span></label
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <AdminInfoLine info_slug="ownership_settings_integrations" />
        </div>
      </div>
    </div>
    <!-- <v-dialog /> -->
  </div>
</template>

<script>
import SettingsMenu from "@/components/admin/SettingsMenu.vue";
import OnBoardingCheckList from "@/components/admin/OnBoardingCheckList.vue";

import OverflowMenu from "@/components/form_elements/OverflowMenu.vue";

import { admin_tp_locations_state_mixin } from "@/utils/admin_tp_locations_state_mixin.js";

import axios from "axios";

export default {
  mixins: [admin_tp_locations_state_mixin()],
  components: {
    SettingsMenu,
    OnBoardingCheckList,
    OverflowMenu
  },
  props: {
    connect_status: {
      type: String,
      default: null
    },
    connected_tp_account_id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      document_title: this.T__("Integrations ‹ Settings"),
      show_add_tp_account_list: false,
      tp_accounts: [],
      tp_accounts_add_list: [
        {
          provider: "zoom_meeting",
          limit: 1,
          count: 0,
          show: true
        },
        {
          provider: "gotomeeting_meeting",
          limit: 1,
          count: 0,
          show: true
        }
      ],
      help_links: {
        zoom_meeting:
          "https://help.wpcal.io/en/category/integrations-zoom-1dfihfm/?utm_source=wpcal_plugin&utm_medium=contextual"
      },
      disconnect_highlight_tp_account_index: null,
      connect_status_notified: false,
      tp_account_overflow_menu_details: {
        open_menu_id: null,
        popper_instance: null
      }
    };
  },
  computed: {
    tp_accounts_add_list_with_stats() {
      let list = this.clone_deep(this.tp_accounts_add_list);
      for (let index in this.tp_accounts) {
        let tp_account = this.tp_accounts[index];

        let list_index = list.findIndex(list_item => {
          return list_item.provider === tp_account.provider;
        });
        if (list_index != undefined) {
          list[list_index].count++;
          if (list[list_index].limit <= list[list_index].count) {
            list[list_index].show = false;
          }
        }
      }
      return list;
    },
    tp_accounts_add_list_final() {
      let list = [];
      for (let index in this.tp_accounts_add_list_with_stats) {
        if (this.tp_accounts_add_list_with_stats[index].show)
          list.push(this.tp_accounts_add_list_with_stats[index]);
      }
      return list;
    },
    enable_add_new_tp_account() {
      let is_enable = this.tp_accounts_add_list_final.length > 0;
      return is_enable;
    }
  },
  methods: {
    add_tp_account(provider, do_ = "add") {
      let action = "add_tp_account";
      if (do_ == "reauth") {
        action = "reauth_tp_account";
      }
      if (provider === "zoom_meeting" || provider === "gotomeeting_meeting") {
        window.location =
          "admin.php?page=wpcal_admin&wpcal_action=" +
          action +
          "&provider=" +
          provider +
          "&wpcal_admin_main_nonce=" +
          this.$store.getters.get_admin_main_nonce;
      }
    },
    load_page() {
      let action = "get_tp_accounts_of_current_admin";
      let wpcal_request = {};
      wpcal_request[action] = {
        dummy__: ""
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          Object.assign(this.$data, this.$options.data.apply(this)); //re-initilize data in Vue - this required as we are using this function to after update
          //console.log(response);
          if (
            response.data &&
            response.data[action].hasOwnProperty("tp_accounts")
          ) {
            this.tp_accounts = response.data[action].tp_accounts;
          }

          this.handle_connect_result();
          this.check_auth_for_tp_accounts();
        })
        .catch(error => {
          console.log(error);
        });
    },
    handle_connect_result() {
      if (!this.connect_status || !this.connected_tp_account_id) {
        return;
      }
      if (this.connect_status_notified) {
        return;
      }

      if (this.connect_status === "connected" && this.tp_accounts.length) {
        for (let index in this.tp_accounts) {
          if (this.tp_accounts[index].id != this.connected_tp_account_id) {
            continue;
          }

          let success_msg = this.Tsprintf(
            /* translators: 1: html-tag-open 2: html-tag-close 3: tp provider 4: account email */
            this.T__(
              "Your %1$s %3$s %2$s account %1$s %4$s %2$s is succesfully connected."
            ),
            "<strong>",
            "</strong>",
            this.$options.filters.tp_provider_name(
              this.tp_accounts[index].provider
            ),
            this.tp_accounts[index].tp_account_email
          );
          let success_title = "Ok";

          this.$toast.success(success_msg, success_title, {});

          //show a popup message
          this.$modal.show("dialog", {
            title: this.T__("App account connected"),
            text: this.Tsprintf(
              /* translators: 1: html-tag-open 2: html-tag-close */
              this.T__(
                "To use a web conferencing app for your bookings, you should edit your existing %1$s event types %2$s or create a new one and add the connected app as a location."
              ),
              '<a href="#/event-types" style="font-size:14px;">',
              "</a>"
            ),
            buttons: [
              {
                title: "Okay",
                default: true, // Will be triggered by default if 'Enter' pressed.
                handler: () => {
                  this.$modal.hide("dialog");
                }
              }
            ]
          });

          //resetting to avoid duplicate notifications
          this.connect_status_notified = true;
          break;
        }
      }
    },
    show_disconnect_confirmation(tp_account, force = false) {
      let dialog_text;
      let yes_button_title;

      if (force) {
        dialog_text = this.Tsprintf(
          /* translators: 1: html-tag 2: html-tag-open 3: html-tag-close 4: tp provider 5: account email */
          this.T__(
            "Oops! Error while disconnecting the account. %1$s Do want to %2$sforce-disconnect%3$s the %1$s %2$s %4$s - %5$s %3$s account?"
          ),
          "<br>",
          "<strong>",
          "</strong>",
          this.$options.filters.tp_provider_name(tp_account.provider),
          tp_account.tp_account_email
        );
        //"Oops! Error while disconnecting the account. <br>Do want to <strong>force-disconnect</strong> the <br>";
        yes_button_title = this.T__("Yes, force-disconnect.");
      } else {
        dialog_text = this.Tsprintf(
          /* translators: 1: html-tag 2: html-tag-open 3: html-tag-close 4: tp provider name 5: account email */
          this.T__(
            "Are you sure you want to disconnect the %1$s %2$s %4$s - %5$s %3$s account?"
          ),
          "<br>",
          "<strong>",
          "</strong>",
          this.$options.filters.tp_provider_name(tp_account.provider),
          tp_account.tp_account_email
        );
        yes_button_title = this.T__("Yes, disconnect.");
      }

      this.$modal.show("dialog", {
        title: this.T__("Disconnect account?"),
        text: dialog_text,
        buttons: [
          {
            title: yes_button_title,
            class: "vue-dialog-button dialog-red-btn",
            handler: () => {
              this.disconnect_tp_account_by_id(tp_account, force);
              this.$modal.hide("dialog");
            }
          },
          {
            title: this.T__("No, don't.")
          }
        ]
      });
    },
    disconnect_tp_account_by_id(tp_account, force = false) {
      let action = "disconnect_tp_account_by_id_for_current_admin";
      let wpcal_request = {};
      wpcal_request[action] = {
        tp_account_id: tp_account.id,
        provider: tp_account.provider,
        force: force === true ? "force_remove" : ""
      };

      let action_get_tp_accounts = "get_tp_accounts_of_current_admin";
      wpcal_request[action_get_tp_accounts] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(response.data[action], {
            success_msg: this.T__("Account is disconnected successfully.")
          });

          if (
            !force &&
            response.data[action] &&
            response.data[action].hasOwnProperty("status") &&
            response.data[action].status == "error"
          ) {
            setTimeout(() => {
              this.show_disconnect_confirmation(tp_account, true);
            }, 1000);
          }

          if (
            response.data &&
            response.data[action_get_tp_accounts].hasOwnProperty("tp_accounts")
          ) {
            this.tp_accounts =
              response.data[action_get_tp_accounts].tp_accounts;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    check_auth_for_tp_accounts() {
      let wpcal_request = {};
      let action_check_auth =
        "check_auth_if_fails_may_remove_tp_accounts_for_current_admin";
      wpcal_request[action_check_auth] = "dummy__";

      let action_get_tp_accounts = "get_tp_accounts_of_current_admin";
      wpcal_request[action_get_tp_accounts] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data, {
          params: { _remove_options_before_call: { background_call: true } }
        })
        .then(response => {
          //console.log(response);
          if (
            response.data[action_check_auth] &&
            response.data[action_check_auth].hasOwnProperty("status") &&
            response.data[action_check_auth].status == "error"
          ) {
            this.notify_single_action_result(response.data[action_check_auth], {
              success_msg: "Account checked successfully.",
              timeout: false
            });
          }

          if (
            response.data &&
            response.data[action_get_tp_accounts].hasOwnProperty("tp_accounts")
          ) {
            this.tp_accounts =
              response.data[action_get_tp_accounts].tp_accounts;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    show_googlemeet_meeting_know_more_dialog() {
      this.$modal.show("dialog", {
        title: this.T__("Heads up!"),
        text: "Google Hangout/Meet will work only with Google Calendar.<br> ",
        buttons: [
          {
            title: this.T__("Okay"),
            default: true // Will be triggered by default if 'Enter' pressed.
          }
        ]
      });
    }

    // sync_all_tp_api() {
    //   //current admin only

    //   //postpone manage_background_task
    //   this.$store.dispatch("manage_background_task", {
    //     initial_time_out: 30000 //30 secs
    //   });

    //   let action = "sync_all_tp_api_for_current_admin";
    //   let wpcal_request = {};
    //   wpcal_request[action] = "dummy__";

    //   let post_data = {
    //     action: "wpcal_process_admin_ajax_request",
    //     wpcal_request: wpcal_request
    //   };

    //   axios
    //     .post(window.wpcal_ajax.ajax_url, post_data, {
    //       params: { _remove_options_before_call: { background_call: true } }
    //     })
    //     .then(response => {
    //       this.load_page();
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // }
  },
  mounted() {
    this.load_page();

    // setTimeout(() => {
    //   this.sync_all_tp_api(); //Improve later - might create freq calls - should be rare admins visiting this page
    // }, 1000);
  }
};
</script>

<style src="@/assets/css/admin_settings.css"></style>
<style>
#wpcal_admin_app ul.add-to-cal li label[for^="add-to-cal-opt"] {
  padding-left: 75px !important;
}
#wpcal_admin_app
  ul.add-to-cal
  li
  label[for^="add-to-cal-opt"].zoom_meeting::before {
  content: url("../../assets/images/gcal.svg");
  position: absolute;
  width: 20px;
  left: 45px;
  top: 12px;
}
#wpcal_admin_app .cal-provider {
  position: relative;
  padding-left: 20px;
  margin-left: 5px;
}
#wpcal_admin_app .cal-list .cal-provider.zoom_meeting::before {
  content: url("../../assets/images/gcal.svg");
  position: absolute;
  width: 15px;
  left: 0;
}
#wpcal_admin_app ul.selector.location li.disabled em {
  font-style: normal;
  opacity: 0.5;
  float: none !important;
}
#wpcal_admin_app ul.selector.location li.disabled span {
  background-color: #afb6d1;
  padding: 1px 5px;
  border-radius: 3px;
  float: right;
  font-size: 11px;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -7px;
}
#wpcal_admin_app ul.selector.location li.disabled .txt-h5 {
  opacity: 0.4;
}
</style>
